import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { environment } from "../../../environments/environment";
import { DatePipe } from "@angular/common";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { Pair } from "../../obj/Pair";
import { EntityBase } from "../../entity/EntityBase";
import { Utility } from "../../entity/Utility";
import { State } from "../../entity/State";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { User } from "../../entity/User";
import { Company } from "../../entity/Company";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "kilowant-seller-assign-utility-dialog",
    templateUrl: "../../../html/incs/seller-assign-utility-dialog.html",
    imports: [FormsModule]
})
export class SellerAssignUtilityDialog extends AbstractSellerComponent {
    utilities: Utility[] = null!;
    allUtilities: Utility[] = null!;
    states: State[] = null!;

    state: State = null!;
    utility: Utility = null!;

    constructor(
        public dialogRef: MatDialogRef<any>,
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private datepipe: DatePipe
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        this.generalService.getDetails()
            .then(u => {
               this.user = u;
               if (this.user==null) {
                  this.router.navigate(["/user/login"], { queryParams: { redirect: this.router.url } });
               }
               this.generalService.getStates(false)
                   .then((states:any) => { this.states = states; this.cdr.detectChanges(); });
               this.generalService.getUtilities(null!)
                   .then((utilities:any) => { this.allUtilities = utilities; this.cdr.detectChanges(); });
             });
    }

    changeState(): void {
       this.utilities = [];
       for (var i=0; i<this.allUtilities.length; i++) {
          if (this.allUtilities[i].state!=null && this.state!=null && this.allUtilities[i].state.id==this.state.id) {
             this.utilities.push(this.allUtilities[i]);
          }
       }
    }

    sendForm(): void {
       if (this.utility!=null && !EntityBase.includes(this.user.utilities, this.utility)) {
          this.user.utilities.push(this.utility);
          this._saveUtility();          
       }
    }

    cancel(): void {
      this.dialogRef.close(null!);
    }

    private _saveUtility(): void {
       this.generalService.updateUtilities(this.user)
       .subscribe((res:any) => {
           this.dialogRef.close(null!);
       },
       (err:any) => {
          if (err.status == 400) {
          }
       });
    }
}